import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/LinksPage.css';
import instaLogo from '../assets/images/instaLogo.webp';
import instaLogoFallback from '../assets/images/instaLogo.png';
import twitchLogo from '../assets/images/twitchLogo.webp';
import twitchLogoFallback from '../assets/images/twitchLogo.png';
import gmailLogo from '../assets/images/gmailLogo.webp';
import gmailLogoFallback from '../assets/images/gmailLogo.png';
import websiteLogo from '../assets/images/websiteLogo.webp';
import websiteLogoFallback from '../assets/images/websiteLogo.png';
import logoVinted from '../assets/images/logoVinted.webp';
import logoVintedFallback from '../assets/images/logoVinted.png';
import { useLanguage } from '../i18n/LanguageContext';
import Picture from '../components/Picture';

function LinksPage() {
    const { t } = useLanguage();

    const links = [
        {
            url: 'https://www.instagram.com/maf_industrie/',
            text: '@maf_industrie',
            description: t('linksPage.instagramDesc'),
            logo: instaLogo,
            logoFallback: instaLogoFallback,
            target: '_blank'
        },
        {
            url: 'mailto:lucasmafrica57@gmail.com',
            text: 'lucasmafrica57@gmail.com',
            description: t('linksPage.emailDesc'),
            logo: gmailLogo,
            logoFallback: gmailLogoFallback,
            target: ''
        },
        {
            url: 'https://maf-industrie.fr/',
            text: t('linksPage.siteText'),
            description: t('linksPage.siteDesc'),
            logo: websiteLogo,
            logoFallback: websiteLogoFallback,
            target: ''
        },
        {
            url: 'https://www.vinted.fr/member/82496574',
            text: t('linksPage.vintedText'),
            description: t('linksPage.vintedDesc'),
            logo: logoVinted,
            logoFallback: logoVintedFallback,
            target: '_blank'
        },
        {
            url: 'https://www.twitch.tv/maf_5',
            text: t('linksPage.twitchText'),
            description: t('linksPage.twitchDesc'),
            logo: twitchLogo,
            logoFallback: twitchLogoFallback,
            target: '_blank'
        }
    ];

    return (
        <div className='page'>
            <Header />
            <main>
                <section className='hero links-hero'>
                    <div className='container links-hero-content'>
                        <p className='eyebrow'>{t('linksPage.eyebrow')}</p>
                        <h1>{t('linksPage.title')}</h1>
                        <p className='lead'>
                            {t('linksPage.lead')}
                        </p>
                    </div>
                </section>
                <section className='section'>
                    <div className='container links-grid'>
                        {links.map((link, index) => (
                            <a
                                key={link.text}
                                href={link.url}
                                target={link.target || undefined}
                                rel={
                                    link.target === '_blank'
                                        ? 'noreferrer'
                                        : undefined
                                }
                                className='link-card reveal'
                                style={{ '--delay': `${index * 0.08}s` }}
                            >
                                <div className='link-icon'>
                                    <Picture
                                        webpSrc={link.logo}
                                        fallbackSrc={link.logoFallback}
                                        alt={link.text}
                                    />
                                </div>
                                <div>
                                    <h3>{link.text}</h3>
                                    <p>{link.description}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}

export default LinksPage;
